import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/tabbar/home-active.png'
import _imports_1 from '@/assets/tabbar/home.png'
import _imports_2 from '@/assets/tabbar/my-active.png'
import _imports_3 from '@/assets/tabbar/my.png'


const _withScopeId = n => (_pushScopeId("data-v-65322247"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  src: _imports_0
}
const _hoisted_2 = {
  key: 1,
  src: _imports_1
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 首页 ")
const _hoisted_4 = {
  key: 0,
  src: _imports_2
}
const _hoisted_5 = {
  key: 1,
  src: _imports_3
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 我的 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_tabbar_item = _resolveComponent("van-tabbar-item")!
  const _component_van_tabbar = _resolveComponent("van-tabbar")!

  return (_openBlock(), _createBlock(_component_van_tabbar, {
    route: "",
    "active-color": "#ee0a24"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_van_tabbar_item, { to: "/home" }, {
        icon: _withCtx((props) => [
          (props.active)
            ? (_openBlock(), _createElementBlock("img", _hoisted_1))
            : (_openBlock(), _createElementBlock("img", _hoisted_2))
        ]),
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_component_van_tabbar_item, { to: "/my" }, {
        icon: _withCtx((props) => [
          (props.active)
            ? (_openBlock(), _createElementBlock("img", _hoisted_4))
            : (_openBlock(), _createElementBlock("img", _hoisted_5))
        ]),
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}